module.exports = __webpack_public_path__ + "static/eye-institute-1366c366307d24be6ffb67b1398354c0.jpg";